module.exports = __webpack_public_path__ + "static/media/Close.097a27bf.svg";